var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgButtonInfromation2 = function SvgButtonInfromation2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.96 14.96",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "button_infromation2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.11,12.4a7.15,7.15,0,0,0,1.78-3.9A7.29,7.29,0,0,0,13.44,3,7.08,7.08,0,0,0,9.3.23,7.29,7.29,0,0,0,1.81,2.61,7.07,7.07,0,0,0,0,6.83s0,.07,0,.09V8.09a5.2,5.2,0,0,1,.11.67,7.36,7.36,0,0,0,2.48,4.37A7.44,7.44,0,0,0,6.47,14.9a2.42,2.42,0,0,1,.46.06H8l.79-.11A7.39,7.39,0,0,0,13.11,12.4ZM7.93,2.89a1.16,1.16,0,0,1,1.16.46.9.9,0,0,1,.2.56,1.16,1.16,0,0,1-2.21.43A1.07,1.07,0,0,1,7.93,2.89Zm-.4,9.16A2.22,2.22,0,0,1,6.68,12a1.19,1.19,0,0,1-.82-1.4,13.25,13.25,0,0,1,.47-1.88,7.64,7.64,0,0,0,.26-1.15c.06-.62-.16-.73-.64-.73a1.72,1.72,0,0,0-.59.12c-.11,0-.12,0-.1-.09.08-.39.08-.39.45-.53A3.72,3.72,0,0,1,7.11,6,1.71,1.71,0,0,1,7.5,6a1.23,1.23,0,0,1,.37.12,1.09,1.09,0,0,1,.66,1,4.08,4.08,0,0,1-.15,1c-.19.69-.42,1.37-.56,2.07a1.64,1.64,0,0,0,0,.54.42.42,0,0,0,.44.41A1.82,1.82,0,0,0,9,11.13c.15-.05.14,0,.13.11a.51.51,0,0,1-.42.49A4.79,4.79,0,0,1,7.53,12.05Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonInfromation2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/button_infromation2.91605f57.svg";
export { ForwardRef as ReactComponent };